import querySerializer from 'query-string';
import _ from 'lodash';

import { redirect } from 'redux-first-router';

import { auth } from '../lib/auth';
import { orgs } from '../lib/orgs';
import { settings } from '../lib/settings';
import { SettingsAPI, OrgAPI } from '../lib/api';

import { receiveSettings } from './actions/Settings';

const API = {
  settings: new SettingsAPI(),
  org: new OrgAPI(),
};

const NOOP = () => Promise.resolve();

export const fetchSettingsData = (state = {}) => {
  const { fetched = false } = state;
  if (fetched) return NOOP;
  return API.settings.get();
};

export const fetchOrgData = (orgId = '') => {
  if (orgs.get(orgId).get('id') || !orgId) {
    return NOOP;
  }
  return API.org.get(orgId);
};


const requiresAuthentication = (user, route) => {
  if (route && route.requiresAuthentication && !user.authenticated) {
    return true;
  }
  return false;
};

const isAuthenticated = user => user.authenticated;

const requiresAuthorization = (user, route) => {
  if (route && (route.role || route.roles)) {
    return true;
  }
  return false;
};

const isAuthorized = (user, route) => {
  const rolesRequired = _.get(route, 'roles', []);
  const roleRequired = _.get(route, 'role');
  if (roleRequired) rolesRequired.push(roleRequired);
  if (rolesRequired && rolesRequired.length && !rolesRequired.includes(user.role)) {
    return false;
  }

  return true;
};

const fetch = ({
  user,
  dispatch,
  getState,
  currentAction = {},
  route = {},
}) => {
  const promise = new Promise((resolve) => {
    const action = currentAction;
    const promises = [];

    promises.push(fetchSettingsData(settings, route));

    Promise.all(promises).then((promisesResp) => {
      const [settingsResp] = promisesResp || [];

      if (settingsResp && settingsResp.data && !_.isEmpty(settingsResp.data)) {
        settings.update({ ...settingsResp.data });
        settings.fetched = true;
        dispatch(receiveSettings(settings.settings));

        const orgsArr = settings.get('user.orgs', []);
        _.each(orgsArr, (o) => {
          orgs.set(o.id, o);
        });
      }

      const updatedUser = {
        ...user,
        ...settings.get('user', {}),
      };

      if (requiresAuthentication(updatedUser, route) && !isAuthenticated(updatedUser)) {
        dispatch(redirect({
          type: 'LOGIN',
          payload: action.payload,
          query: _.get(action, 'meta.query', {}),
          errorMessage: 'You must be logged in to complete this action',
        }));
        resolve();
      }


      // @TODO
      // const orgIds = _.map(settings.get('user.orgs', []), o => o.id);
      // if (orgId &&
      //   orgId !== 'default' &&
      //   !orgIds.includes(orgId) && updatedUser.role !== 'admin'
      // ) {
      //   auth.logout();
      //   dispatch(redirect({
      //     type: 'LOGIN',
      //     payload: {},
      //     query: {},
      //     errorMessage: 'Unauthorized',
      //   }));
      //   resolve();
      // }

      if (requiresAuthorization(updatedUser, route) && !isAuthorized(updatedUser, route)) {
        auth.logout();
        dispatch(redirect({
          type: 'LOGIN',
          payload: action.payload,
          query: _.get(action, 'meta.query', {}),
          errorMessage: 'Unauthorized',
        }));
        resolve();
      }

      if (route.fetchPreRender && _.isFunction(route.fetchPreRender)) {
        route.fetchPreRender(dispatch, getState).then(() => {
          dispatch({ type: `__PAGE__${action.type}`, payload: action.payload, query: _.get(action, 'meta.query', {}) });
          resolve();
        }).catch((e) => {
          console.error(e);
          dispatch({ type: 'GLOBAL_ERROR', errorMessage: 'Something went wrong.' });
          resolve();
        });
      } else {
        dispatch({ type: `__PAGE__${action.type}`, payload: action.payload, query: _.get(action, 'meta.query', {}) });
        resolve();
      }
    }).catch(() => {
      settings.clear();
      auth.logout();
      dispatch(redirect({
        type: 'LOGIN',
        payload: action.payload,
        query: {
          ..._.get(action, 'meta.query', {}),
          logout: 'true',
        },
        errorMessage: 'Unauthorized',
      }));
      resolve();
    });
  });

  return promise;
};

export default {
  querySerializer,
  title: (state) => {
    const map = state.location.routesMap[state.location.type];
    const title = map && map.title ? map.title : '';
    if (_.isFunction(title)) {
      return title(state);
    }

    if (title) {
      return title;
    }

    if (state.title) {
      return state.title;
    }

    return 'Blumira';
  },
  onBeforeChange: (dispatch, getState, action) => {
    const currentAction = action.action;
    const state = getState();

    const {
      location: { routesMap = {}, payload = {} },
    } = state;

    let orgId = _.get(action, 'action.payload.orgId', '');

    if (orgId) {
      action.action.payload.orgId = orgId;
    }

    orgId = orgId || payload.orgId || '';
    const route = routesMap[currentAction.type];

    const userSettings = settings.user || {};
    const user = {
      authenticated: auth.isAuthenticated(),
      role: '',
      ...userSettings,
    };

    fetch({
      user,
      dispatch,
      getState,
      orgId: orgId.toLowerCase(),
      currentAction,
      route,
    });
  },
  onAfterChange: (dispatch, getState) => { // eslint-disable-line

  },
};



// WEBPACK FOOTER //
// ./src/redux/reduxFirstRouterOptions.js